import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OnlineApplicationComponent } from './online-application/online-application.component'
import { OnlineApplicationConfirmationComponent } from './online-application-confirmation/online-application-confirmation.component'
const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'ApplyOnline'},
  { path: 'ApplyOnline', component: OnlineApplicationComponent, data: { title: 'Apply Online' } },
  { path: 'ApplyOnline/:id/:address', component: OnlineApplicationComponent, data: { title: 'Apply Online' } },
  { path: 'apply_online_confirmation', component: OnlineApplicationConfirmationComponent, data: { title: 'Apply Online' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OnlineApplicationRoutingModule { }
